<template lang="pug">
  v-row
    v-col(cols=12 lg=5 v-if="(mobile && !showMap) || !mobile")
      v-tabs(v-model="tab")
          v-tab 1. Driver Profile
          v-tab 2. Plan a trip
          v-tab(:disabled="routeData == null") 3. Results
      v-tabs-items(v-model="tab" class="full-height-tab")
          v-tab-item
              DriverProfile(:models="modelData" :cars="carData"  @changeCar="changeCar" :driver="driver" @updateTrip="queueTrip" :selectedCar="selectedCar" ref="driverProfile"   @next="nextTab(1)")
          v-tab-item
              PlanTrip(class="ma-1 pa-2" ":trips"="trips" @tripUpdated="queueTrip" @next="nextTab(2)" @selectionChanged="selectionChanged" :selectedTrip="selectedTrip", :myAddress="myAddress")
          v-tab-item
              RoutePlanResults(:stops="routeData" :tripSummary="tripSummary" :trip="selectedTrip" :driver="driver", :summary="this.routeData ? this.routeData.route_summary : {}" :car="selectedCar" :chargers="chargers")
    v-col(cols=12 lg=7)
      PlannerMap(v-if="(mobile && showMap) || !mobile" :routeData="routeData" :chargers="chargers" :trip="selectedTrip" :myCar="myCar" @updateCar="updateMyCar" @changeCar="changeCar")   
    v-snackbar(v-model="snackbar" :timeout="-1") {{ messageText }}
      v-btn(v-if="!waiting" color="pink" text @click="snackbar = false") Close
      v-progress-circular(v-if="waiting" color="pink" indeterminate)
</template>

<script>
import PlannerMap from "../components/PlannerMap.vue";
import EVNav from "../services/api/EVNav.js";
import PowerTrip from "../services/api/PowerTrip.js";
import PlanTrip from "../components/PlanTrip.vue";
import DriverProfile from "../components/DriverProfile.vue";
import RoutePlanResults from "../components/RoutePlanResults.vue";
import {headerBus} from "../main";
import Geotab from '../services/api/Geotab';
import _ from 'lodash';
export default {
  data() {
    return {
      tab: null,
      mapVisible: false,
      routeData: null,
      chargers: null,
      trips: this.$trips,
      selectedTrip: null,
      selectedCar: null,
      carYear: 2020,
      timer: null,
      driver: {
        aa: 50,
        sa: 0,
        soh: 100,
        battery: 100,
        passengers: 1,
        batteryMin: 20,
        batteryMax: 95,
        extraWeight: 0
      },
      snackbar: false,
      messageText: "",
      waiting: true,
      tripSummary: "",
      myCar: null,
      myAddress: null,
      modelData: this.$modelData
    };
  },
    async created() {
           headerBus.$on('toggleMap', ()=> {
            this.mapVisible = !this.mapVisible;
        });
        this.myCar = await Geotab.getCarData();

  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
    showMap() {
      if (this.$vuetify.breakpoint.name == "lg") {
        return true;
      }
      return this.mapVisible;
    }
  },
  methods: {
    async changeCar(car) {
      Geotab.deviceName = car.Name;
        this.$refs.driverProfile.setToCar();
        let carModel = this.modelData.find((item)=>item.ID == car.EVModelID);

              let c = await Geotab.getCarData();
       c.soc = await Geotab.getStateOfCharge(c.id);
      c.status = await Geotab.getDeviceStatus(c.id);

      await this.updateMyCar(c);
              this.updateCar(carModel);
    },
     updateMyCar(car) {

      this.driver.battery=car.soc;
     // let address = await EVNav.reverseGeocode({lat:car.status.latitude,lng:car.status.longitude});
     if (this.myAddress == null || this.myAddress.Address.Address.startsWith("My ")) {
      this.myAddress = {Address:{Address:"My " + car.name,properties:{},geometry:{coordinates:[car.status.longitude,car.status.latitude]}}};
     }
      if (this.$trips.length > 0) {
        this.$trips[0].fromAddress = _.cloneDeep(this.myAddress);
      } 
     
    },
    selectionChanged(trip) {
      if (this.selectedTrip == null || trip.id != this.selectedTrip.id) {
        this.selectedTrip = trip;
        this.queueTrip();
      }
    },
    queueTrip() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.calculateTrip,1000);
    },
    calculateTrip() {
      this.timer = null;
      if (this.selectedTrip) {
        var $this = this;

        if (
          this.selectedTrip.fromAddress != null &&
          this.selectedTrip.fromAddress.Address != null &&
          this.selectedTrip.toAddress != null &&
          this.selectedTrip.toAddress.Address != null && 
          this.selectedCar != null
        ) {
          this.showMessage(
            "Planning route for " + this.selectedTrip.title + "...",
            true
          );
          this.routeData = null;

          EVNav.planRoute(
            this.selectedTrip,
            this.selectedCar,
            this.driver
          ).then(response => {

            this.routeData = response;
            if (this.routeData.points == undefined) {
              this.showMessage("We can't find a suitable route for these settings.");
            } else {
              let time = this.niceDuration(
                this.routeData.route_summary.duration
              );

              let cost =
                "$" +
                this.formatPrice(this.routeData.route_summary.charging_cost);
              let distance = Math.round(
                this.routeData.route_summary.distance / 1000
              );

              this.tripSummary = 
                this.selectedTrip.title +
                  " is " +
                  distance +
                  "kms will take " +
                  time +
                  " and cost around " +
                  cost;
                  $this.snackbar = false;
            }
          });
        }
      }
    },
    async updateCar(car) {
      
      this.selectedCar = car;
   //   this.queueTrip();
    },
    showMessage(message, waiting = false) {
      this.messageText = message;
      this.waiting = waiting;
      this.snackbar = true;
    },
       nextTab(index) {
      this.tab = index;
    },
  },
  mounted: function() {
    if (localStorage.getItem("driver")) {
      this.driver = JSON.parse(localStorage.getItem("driver"));
    }

   /* if (localStorage.getItem("trips")) {
      this.trips = JSON.parse(localStorage.getItem("trips"));
      if (this.trips.length > 0) {
        this.selectedTrip = this.trips[0];
      }
    }*/
          if (this.trips.length > 0) {
        this.selectedTrip = this.trips[0];
        this.tab = 1;
      }
    if (localStorage.getItem("car")) {
      this.selectedCar = JSON.parse(localStorage.getItem("car"));
      this.queueTrip();
    }
    //
    PowerTrip.getChargingStations().then(
      stations => (this.chargers = stations)
    );
  },
  components: {
    PlannerMap,
    PlanTrip,
    DriverProfile,
    RoutePlanResults
  },
  watch: {
    selectedCar(newCar) {
      const parsed = JSON.stringify(newCar);
      localStorage.setItem("car", parsed);
    },
    driver: {
      handler: function(newDriver) {
        const parsed = JSON.stringify(newDriver);
        localStorage.setItem("driver", parsed);
      },
      deep: true
    },
    trips: {
      handler: function(newTrips) {
        const parsed = JSON.stringify(newTrips);
        localStorage.setItem("trips", parsed);
        if (this.myAddress && this.$trips.length > 0) {
              this.$trips[0].fromAddress = this.myAddress;
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.v-tabs-items.full-height-tab  .v-window-item {
  height: calc(100vh - 160px); /* Adjust 270px to suits your needs */
  width:100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
